import { CommonModule, isPlatformServer } from '@angular/common';
import { NgModule, PLATFORM_ID } from '@angular/core';

import { CoreModule } from '~/core/core.module';

import { environment } from 'src/environments/environment';

import { IsEnabledDirective } from './directives/is-enabled.directive';
import { DummyService } from './services/dummy.service';
import { ToggleService } from './services/toggle.service';
import {
  UnleashService,
  UNLEASH_ALWAYS_ENABLE,
  UNLEASH_ENV,
  UNLEASH_SECRET,
  UNLEASH_TENANT,
  UNLEASH_URL,
  UNLEASH_REFRESH_INTERVAL,
} from './services/unleash.service';

/**
 * Unleash management
 */
@NgModule({
  declarations: [IsEnabledDirective],
  providers: [
    {
      provide: UNLEASH_URL,
      useValue: environment.applications.unleash.proxyUrl,
    },
    {
      provide: UNLEASH_SECRET,
      useValue: environment.applications.unleash.secret,
    },
    {
      provide: UNLEASH_ENV,
      useValue: environment.applications.unleash.environment,
    },
    {
      provide: UNLEASH_TENANT,
      useValue: environment.tenant,
    },
    {
      provide: UNLEASH_ALWAYS_ENABLE,
      useValue: environment.applications.unleash.alwaysEnableFeatures,
    },
    {
      provide: UNLEASH_REFRESH_INTERVAL,
      useValue: environment.applications.unleash.refreshInterval,
    },
    {
      provide: ToggleService,
      useFactory: (
        dummyService: DummyService,
        unleashService: UnleashService,
        alwaysEnable: boolean,
        platformID: string
      ) => {
        if (isPlatformServer(platformID) || alwaysEnable) {
          return dummyService;
        }
        return unleashService;
      },
      deps: [DummyService, UnleashService, UNLEASH_ALWAYS_ENABLE, PLATFORM_ID],
    },
  ],
  imports: [CommonModule, CoreModule],
  exports: [IsEnabledDirective],
})
export class TogglesModule {}
